module.exports = __webpack_public_path__ + "static/media/leaf-heart.22fc5627.svg";